<template>
  <v-sheet color="transparent" v-for="specialist in p_full" :key="specialist">
    <MiniUser__WP_Module :specialist="specialist" :day="day" @delete="delete_specialist(specialist.guid)" />
  </v-sheet>
</template>

<script>
import { Specialists } from "@/store/wp_planner/specialists.store";
import { InfoBlock } from "@/store/wp_planner/info.store";
import { ShortenNames } from "@/store/wp_planner/settings.store";
import moment from "moment";
import MiniUser__WP_Module from "@/components/wp_planner/module/miniuser.module.vue";

export default {
  name: "Specialist__Mini_InfoCard",
  components: {MiniUser__WP_Module},
  props: ['modelValue', 'day'],
  methods: {
    moment,
    delete_specialist: function (guid) {
      let index_of_deleting_element = this.persons.findIndex(el => el === guid)
      this.persons.splice(index_of_deleting_element, 1)
    }
  },
  computed: {
    shorten_names: {
      get() {
        return ShortenNames().get()
      },
      set(v) {
        ShortenNames().set(v)
      }
    },
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
    p_full() {
      let humans = []
      for (let guid of this.persons) {
        if (this.specialists) {
          let spec = this.specialists[this.specialists.findIndex(el=> el.guid === guid)]
          //console.log(spec)
          if (spec) {
            humans.push(spec)
          } else {
            humans.push({
              guid: guid,
              name: false
            })
          }
        }
      }
      return humans
    },
    persons: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
